import { FC, useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import {
  ExpandedTable,
  IButton,
  StoredPagination,
  ITooltip,
} from "../../ui-kit";
import { PlusIco, TrashIco } from "../../assets/customIcons";
import SmsSettingsListForm from "./form/list";
import smsSettings from "../../store/smsSettings";
import { useStatusMessage } from "../../hooks/useStatusMessage";

import styles from "./SmsSettings.module.scss";
import Constants from "../../constants/Common";
import { IIncidentItem } from "./SmsIncidentParams";

export type SmsSettingClientGroupClientType = {
  id: number
  name: string
  email: string
  phoneNumber: string
  employeeId: number
  groupId: number
  notificationType: number
  from: string
  to: string
}

export type SmsSettingClientGroupType = {
  id?: number;
  name: string;
  meta?: any;
  eventSeverity?: IIncidentItem;
  eventSeverityId: number;
  clients: SmsSettingClientGroupClientType[];
};

const INITIAL_DISTRIBUTION_LIST_DATA: SmsSettingClientGroupType = {
  id: 0,
  meta: null,
  name: "",
  eventSeverityId: null,
  clients: [],
};

const SmsSettingsDistribution: FC = observer(() => {
  const {
    titleIcons: { trash },
  } = Constants;
  const {
    distributionListStatus,
    distributionListsAreLoading,
    distributionListsData,
    distributionListDataPaginator,
    distributionListRowKeys,
  } = smsSettings;
  const [addForm, toggleAddForm] = useState(false);

  useStatusMessage(distributionListStatus);

  useEffect(() => {
    smsSettings.getSmsIncidentsParams(false);
  }, []);

  useEffect(() => {
    smsSettings.getSmsDistributionsLists();
  }, [
    distributionListDataPaginator.page,
    distributionListDataPaginator.perPage,
  ]);

  const columns = [
    {
      title: "№",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) => index + 1,
      width: "5%",
    },
    {
      title: "Название группы",
      dataIndex: "name",
      key: "name",
      className: "align-left",
      width: "95%",
    },
    {
      title: " ",
      key: "delete",
      render: (text, record, index) => (
        <ITooltip title={trash} placement="right">
          <TrashIco onClick={(e) => deleteData(e, record.id)} />
        </ITooltip>
      ),
      className: "delete-cell",
    },
  ];

  const deleteData = (e, id) => {
    e.stopPropagation();

    smsSettings.deleteSmsDistributionList(id);
  };

  return (
    <div className={styles.SmsSettingsPage}>
      <ExpandedTable
        columns={columns}
        data={distributionListsData}
        rowKey={(record) => record.id}
        rowKeys={distributionListRowKeys.keys}
        setRowKeys={distributionListRowKeys.setKeys}
        rowsLength={distributionListDataPaginator.perPage}
        loading={distributionListsAreLoading.value}
      >
        <SmsSettingsListForm />
      </ExpandedTable>
      <StoredPagination {...distributionListDataPaginator} />
      <IButton
        size="medium"
        onClick={(e) => toggleAddForm((addForm) => !addForm)}
        className={styles.SmsSettingsAddButton}
      >
        <PlusIco /> Добавить группу
      </IButton>
      {addForm && (
        <SmsSettingsListForm record={INITIAL_DISTRIBUTION_LIST_DATA} />
      )}
    </div>
  );
});

export default SmsSettingsDistribution;
